define('view/controller/booking/datetime/flexible-provider/TimeFlexibleProviderView',['require','view/controller/booking/datetime/TimeDefaultView','lib/Utils','view/controller/booking/datetime/flexible-provider/TimeFlexibleProviderItemView','Config'],function (require) {

    var TimeDefaultView = require('view/controller/booking/datetime/TimeDefaultView');
    var Utils = require('lib/Utils');
    var TimeFlexibleProviderItemView = require('view/controller/booking/datetime/flexible-provider/TimeFlexibleProviderItemView');
    var Config = require('Config');

    /**
     * Flexible provider timeline view (container)
     *
     * @class TimeFlexibleProviderView
     */
    return TimeDefaultView.extend({

        _timeline: [],
        _timelineHours: [],

        template: '#time_flexible_provider_view',
        childView: TimeFlexibleProviderItemView,
        childViewContainer: '#sb_time_flexible_provider_container',
        childEvents: {
            'hover:providertime': 'onProviderTimeHover',
            'select:providertime': 'onProviderTimeSelected'
        },

        childViewOptions: function (model, index) {
            var result = TimeDefaultView.prototype.childViewOptions.apply(this, model, index);

            result.timeline = this._timeline;
            result.clientTimeZone = this.getOption('clientTimeZone');

            if(model.get('date')) {
                result.isDayOff = this._calendarCollection.isDayOff(model.get('date'));
                result.isWlAvailable = this._calendarCollection.isWlAvailable(model.get('date'));
            } else {
                result.isDayOff = false;
                result.isWlAvailable = false;
            }

            return result;
        },

        initialize: function () {
            this.listenTo(this.collection, 'sync', this.renderTimeline);
            this.listenTo(this.getOption('clientTimeZone'), 'sync', this.renderTimeline);

            this._calendarCollection = this.getOption('calendarCollection');

            TimeDefaultView.prototype.initialize.apply(this);

            if (this.collection.length) {
                this.renderTimeline();
            }

            this.listenTo(this._calendarCollection, 'sync', _.bind(function () {
                this.renderTimeline();
            }, this));
        },

        renderTimeline: function () {
            this._prepareTimeline();
            this.render();
        },

        onProviderTimeHover: function (event, data) {
            var model = data.model;
            var provider = data.provider;
            
            this.collection.each(function(providerTimeline) {
                providerTimeline.collection.each(function (m) {
                    if (model.get('id') === m.get('id') && provider == providerTimeline.id) {
                        return;
                    }
                    
                    var state = m.get('state') || '';
                    if (_.contains(state.split(' '), 'hovered')) {
                        m.set('state', '');
                    }
                });
            });
            
            var totalRequiredSlots = this._getSlotsToBook();
            var actualServiceSlots = this._getActualServiceSlots();
            _.each(this._getAvailableSlotModels(model, provider), function (m, index) {
                if (index < actualServiceSlots) {
                    m.set('state', 'hovered');
                } else {
                    m.set('state', 'hovered buffertime');
                }
            });
        },

        onProviderTimeSelected: function (event, data) {
            var model = data.model;
            var provider = data.provider;
            var providerTimeline = this.collection.get(provider);

            var slotsCount = this._getSlotsToBook();
            var actualServiceSlots = this._getActualServiceSlots();
            if (Config.getInstance().getOption('allow_buffertime_extend') == "1") {
                slotsCount = actualServiceSlots;
            }
            
            var availableSlots = this._getAvailableSlotModels(model, provider);

            if (availableSlots.length < slotsCount) {
                if (!availableSlots.length) {
                    this.showErrorMessage(Locale.getNonEscape('selected_slots_are_not_available'));
                    return false;
                }
                var lastSlotModel = _.last(availableSlots);
                if (lastSlotModel !== providerTimeline.collection.last() && !Config.getInstance().isAllowedBookOverBreaktime()) {
                    this.showErrorMessage(Locale.getNonEscape('selected_slots_are_not_available'));
                    return false;
                } else if (!Config.getInstance().isAllowedBookOverDay()) {
                    this.showErrorMessage(Locale.getNonEscape('selected_slots_are_not_available'));
                    return false;
                }
            }

            this.triggerMethod('timeAndProviderChanged', model.get('time'), model.get('date'), provider);
        },

        isTimeCollectionEmpty: function () {
            return (!this._timeline || !this._timeline.length || !this.getOption('clientTimeZone').isReady());
        },

        serializeData: function () {
            var result = TimeDefaultView.prototype.serializeData.apply(this);

            result.time_diff = Utils.timeDiff(this._timelineHours[0], this.getOption('clientTimeZone'));
            result.timeline = this._timelineHours;
            result.isEmptyDay = !this._timeline.length || !this.getOption('clientTimeZone').isReady();

            var waitingListHelperModel = this.getOption('waitingListHelperModel');
            if(waitingListHelperModel) {
                result.is_available_date = waitingListHelperModel.isTodayOrFutureDates() && waitingListHelperModel.isWorkDateInterval();
            }

           // console.log(this.collection);

            //result.is_available_date = true;

            return result;
        },

        _prepareTimeline: function() {
            var clientTimeZone = this.getOption('clientTimeZone');

            if (!clientTimeZone.isReady()) {
                this._timeline = [];
                this._timelineHours = [];
            } else {
                this._timeline = this.collection.getCombinedTimeline();
                // hour column labels: per-date client offset of the slots in each hour
                this._timelineHours = _.map(this.collection.getCombinedTimelineHours(), function (hour) {
                    hour.time_diff = Utils.timeDiff(hour, clientTimeZone);
                    return hour;
                });
            }
        },

        _getAvailableSlotModels: function (model, provider) {
            var result = [];
            var slots = this._getSlotsToBook();
            var providerTimeline = this.collection.get(provider);

            var start = providerTimeline.collection.findIndex(model);

            for (var i = start; i < providerTimeline.collection.length; i++) {
                var hModel = providerTimeline.collection.at(i);

                // means that we do not allow to extend booking over the day
                if (hModel.get('date') !== model.get('date') && !Config.getInstance().isAllowedBookOverDay()) {
                    break;
                }
                // allowed to book if the slot is free
                if (hModel.get('type') === 'free') {
                    result.push(hModel);
                    slots--;
                // do not allow if slot is reserved
                } else if (hModel.get('type') === 'reserved') {
                    return [];
                // do not allow to extend booking over the breaktime
                } else if (!Config.getInstance().isAllowedBookOverBreaktime()) {
                    break;
                }
                // found all slots to book
                if (slots === 0) {
                    break;
                }
            }

            return result;
        },

        _getSlotsToBook: function () {
            var slots = 1;
            
            if (this.getOption('bookingModel').get('service')) {
                var products = this.getOption('bookingModel').getProductsAddonsList();
                products = products ? products.map(function (product) { return product.duration; }) : [];
                var productsDuration = _.reduce(products, function (a, b) { return +a + +b; }, 0);
                
                var duration = ~~this.getOption('bookingModel').get('service').duration + ~~this.getOption('bookingModel').get('service').buffertime_after + productsDuration;
                
                slots = duration / Config.getInstance().getTimeFrame();
            }

            return slots;
        },
        
        _getActualServiceSlots: function () {
            var slots = 1;
            
            if (this.getOption('bookingModel').get('service')) {
                var products = this.getOption('bookingModel').getProductsAddonsList();
                products = products ? products.map(function (product) { return product.duration; }) : [];
                var productsDuration = _.reduce(products, function (a, b) { return +a + +b; }, 0);
                
                var duration = ~~this.getOption('bookingModel').get('service').duration + productsDuration;
                slots = duration / Config.getInstance().getTimeFrame();
            }

            return slots;
        },

    });

});

